import React from 'react';
import T from '../styles/theme';

const fmtDate = (d) => {
  if (!d) return "";
  try {
    return new Intl.DateTimeFormat(undefined, { weekday: "long", month: "short", day: "numeric" }).format(new Date(d));
  } catch (_e) { return ""; }
};
const fmtTime = (d) => {
  if (!d) return "";
  try {
    return new Intl.DateTimeFormat(undefined, { hour: "numeric", minute: "2-digit" }).format(new Date(d));
  } catch (_e) { return ""; }
};
const fmtRange = (start, end) => {
  if (!start) return "";
  const sd = new Date(start);
  if (!end) return fmtDate(sd) + " · " + fmtTime(sd);
  const ed = new Date(end);
  const sameDay = sd.toISOString().slice(0, 10) === ed.toISOString().slice(0, 10);
  if (sameDay) return fmtDate(sd) + " · " + fmtTime(sd) + " – " + fmtTime(ed);
  return fmtDate(sd) + " " + fmtTime(sd) + " – " + fmtDate(ed) + " " + fmtTime(ed);
};

const joinLabel = (url) => {
  if (!url) return "Join Meeting";
  const u = url.toLowerCase();
  if (u.includes("meet.google.com")) return "Join Google Meet";
  if (u.includes("zoom.us")) return "Join Zoom";
  if (u.includes("teams.microsoft.com")) return "Join Teams";
  if (u.includes("webex.com")) return "Join Webex";
  return "Join Meeting";
};

export default function CalendarInviteCard({ event }) {
  if (!event || !event.title || !event.start) return null;

  const isCancelled = event.status === "cancelled";
  const statusStyles = {
    confirmed: { bg: "rgba(46,139,87,0.12)", color: "#2E8B57", label: "Confirmed" },
    tentative: { bg: "rgba(212,118,58,0.12)", color: "#D4763A", label: "Tentative" },
    cancelled: { bg: "rgba(229,57,53,0.12)", color: "#E53935", label: "Canceled" },
  };
  const pill = statusStyles[event.status] || null;

  return (
    <div style={{
      borderRadius: 12, border: "1px solid rgba(217,219,221,0.12)",
      background: "rgba(255,255,255,0.02)", padding: 16,
      position: "relative", marginBottom: 14, maxWidth: 640,
    }}>
      {pill && (
        <div style={{
          position: "absolute", top: 12, right: 12,
          padding: "3px 10px", borderRadius: 999,
          background: pill.bg, color: pill.color,
          fontSize: 10, fontWeight: 500, letterSpacing: ".04em", textTransform: "uppercase",
        }}>{pill.label}</div>
      )}

      <div style={{
        fontSize: 16, fontWeight: 400, color: T.txt, marginBottom: 6,
        paddingRight: pill ? 90 : 0,
        textDecoration: isCancelled ? "line-through" : "none",
        opacity: isCancelled ? 0.6 : 1,
      }}>
        {event.title}
      </div>

      <div style={{ fontSize: 12, color: T.tx2, marginBottom: 8 }}>
        {fmtRange(event.start, event.end)}
      </div>

      {event.location && (
        <div style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 12, color: T.tx2, marginBottom: 6 }}>
          <span style={{ fontSize: 12 }}>📍</span>
          <span>{event.location}</span>
        </div>
      )}

      {event.organizer && (
        <div style={{ fontSize: 11, color: T.tx3, opacity: 0.8, marginBottom: 10 }}>
          Organizer: {event.organizer}
        </div>
      )}

      {event.joinUrl && !isCancelled && (
        <a
          href={event.joinUrl}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: "inline-block", padding: "7px 14px", borderRadius: 8,
            background: "#4059AD", color: "#FAFAFA", fontSize: 12, fontWeight: 500,
            textDecoration: "none", fontFamily: "inherit",
            boxShadow: "0 2px 12px rgba(64,89,173,0.30)",
          }}
        >
          {joinLabel(event.joinUrl)}
        </a>
      )}
    </div>
  );
}
